import { render, staticRenderFns } from "./Retrospective.vue?vue&type=template&id=4a52ef3d&scoped=true"
import script from "./Retrospective.vue?vue&type=script&lang=js"
export * from "./Retrospective.vue?vue&type=script&lang=js"
import style0 from "./Retrospective.vue?vue&type=style&index=0&id=4a52ef3d&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a52ef3d",
  null
  
)

export default component.exports